const List = () => import("~/components/Views/Prova/RealizarProva/List");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Gerenciamento", link: "" }
];

export const minhasProvas = [
  {
    path: "gerenciamento/minhas-provas",
    component: List,
    name: "Minhas Aplicações de Provas",
    meta: {
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/gerenciamento/minhasProvas.js